import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { getJson } from '@hcr/api/shared'

import type { ErrorDto, PointsExchangeInfoDto } from '../../dtos'
import { PointsExchangeInfoDtoSchema } from '../../dtos'

export const createPointsExchangeDetailsQueryKey = () => ['optimizely', 'pointsExchangeDetails']

export const createPointsExchangeDetailsQuery =
  (baseUrl: string) =>
  <Data = PointsExchangeInfoDto>(options?: Partial<UseQueryOptions<PointsExchangeInfoDto, ErrorDto, Data>>) =>
    useQuery<PointsExchangeInfoDto, ErrorDto, Data>({
      ...options,
      queryKey: createPointsExchangeDetailsQueryKey(),
      queryFn: () =>
        getJson({
          schema: PointsExchangeInfoDtoSchema,
          url: `${baseUrl}/owners/points-exchange`,
        }),
    })
